<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useChatStore} from "../../../store/chat"
import {useModalStore} from "../../../store/modal"
import {computed, onMounted, ref} from "vue";
import {useRouter} from "vue-router";

const options = [
    {value: 'start_chat_new_orders', label: 'Sign up as a migration while the (New orders)'},
    {value: 'start_chat_pending_orders', label: 'Are you still interested (Pending orders)'},
    {value: 'start_chat_retentions_suspended', label: 'Retentions - Suspended'},
    {value: 'start_chat_retentions_cancelled', label: 'Retentions - Cancelled'},
    {value: 'start_chat_duplicate_accounts', label: 'Duplicate accounts'},
    {value: 'start_chat_duplicate_accounts_verification', label: 'Duplicate accounts/ Address verification'},
    {value: 'start_chat_new_order_line_release', label: 'New order - Line Release'},
    {value: 'start_chat_awaiting_install_unreachable', label: 'Awaiting Install - Unreachable'},
    {value: 'reseller_refund_request', label: 'Request Banking Details'}
]
const loading = ref(false)
const store = useChatStore()
const modalStore = useModalStore()
const is_created = ref(false)
const router = useRouter()


const description = computed(() =>
    is_created.value
        ? "Chat has been created."
        : "Please select a template to start the chat."
)
const template = ref(null)

const createChat = async () => {
    loading.value = true
    await store.createChat(modalStore.props.uuid, template.value)
    loading.value = false
    is_created.value = true

    await router.push(`/chats/view/${store.chat?.id}`)
}

onMounted(async () => {})
</script>

<template>
    <DefaultModalBase :description :heading="is_created ? 'Chat Created' : 'Create Chat'"
                      :icon="is_created ? 'check-all' : 'call-default'" :loading :refresh="is_created">

        <div class="chat-assign-container">
            <brand-button variant="secondary" v-if="is_created" @click="modalStore.close(true)">Done</brand-button>
            <brand-form-select label="Chat start template." :options="options" v-model="template" v-if="!is_created"/>
            <brand-button @click="createChat()" :disabled="loading || !template" v-if="!is_created">Create Chat</brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.chat-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
